<!-- eslint-disable vue/require-v-for-key -->
<template>
  <div class="wrapper-profile">
    <v-form class="v-form" ref="form" @submit.prevent>
      <h2>Реквизиты победителя</h2>
      <p class="text">Чтобы мы могли передать ваш приз - заполните анкету с вашими данными</p>
      <div class="inputs">
        <v-text-field
          dense
          class="white-input"
          outlined
          clearable
          label="Email"
          placeholder="example@yandex.ru"
          v-model="email"
          :rules="[rules.requiredEmail]"
          @blur="validateField('email')"
        />

        <v-text-field
          dense
          outlined
          clearable
          label="ФИО"
          placeholder="Иванов Иван Иванович"
          v-model="fio"
          :rules="[rules.requiredFio]"
          @blur="validateField('fio')"
        />

        <v-text-field
          dense
          outlined
          clearable
          label="Дата рождения"
          placeholder="ДД.ММ.ГГГГ"
          v-mask="'##.##.####'"
          v-model="birthDate"
          :rules="[rules.requiredBirthDate]"
          @blur="validateField('birthDate')"
        />

        <v-text-field
          dense
          outlined
          clearable
          label="Телефон"
          placeholder="+7 (000) 000-00-00"
          v-mask="'+7 (###) ###-##-##'"
          v-model="phone"
          :rules="[rules.requiredPhone]"
          @blur="validateField('phone')"
        />

        <v-text-field
          dense
          outlined
          clearable
          label="ИНН"
          placeholder="000000000000"
          maxlength="12"
          counter
          v-mask="'############'"
          v-model="inn"
          :rules="[rules.requiredInn]"
          @blur="validateField('inn')"
        />

        <v-text-field
          dense
          outlined
          clearable
          label="СНИЛС"
          placeholder="00000000000"
          maxlength="11"
          counter
          v-mask="'###########'"
          v-model="snils"
          :rules="[rules.requiredSnils]"
          @blur="validateField('snils')"
        />

        <v-text-field
          v-if="this.userPrize === 'rub150k'"
          dense
          outlined
          clearable
          label="Реквизиты банковского счета"
          placeholder=""
          v-model="bankAccountDetails"
          :rules="[rules.requiredBankAccountDetails]"
          @blur="validateField('bankAccountDetails')"
        />

        <p class="gray-text" style="text-align: left; padding-bottom: 20px">Паспортные данные</p>

        <v-text-field
          dense
          outlined
          clearable
          label="Серия и номер"
          v-mask="'#### ######'"
          v-model="passportSerialNumber"
          :rules="[rules.requirePassportSerialNumber]"
          @blur="validateField('passportSerialNumber')"
        />

        <v-text-field
          dense
          outlined
          clearable
          label="Когда выдан"
          v-mask="'##.##.####'"
          v-model="passportWhenIssued"
          :rules="[rules.requirePassportWhenIssued]"
          @blur="validateField('passportWhenIssued')"
        />

        <v-text-field
          dense
          outlined
          clearable
          label="Кем выдан"
          v-model="passportIssuedBy"
          :rules="[rules.requireIssuedByRules]"
          @blur="validateField('passportIssuedBy')"
        />

        <v-text-field
          dense
          outlined
          clearable
          label="Адрес регистрации"
          v-model="passportRegistrationAddress"
          :rules="[rules.requirePassportRegistrationAddress]"
          @blur="validateField('passportRegistrationAddress')"
        />

        <v-text-field
          dense
          outlined
          clearable
          label="Адрес доставки приза"
          v-model="destinationPrizeAddress"
          :rules="[rules.requiredDestinationPrizeAddress]"
          @blur="validateField('destinationPrizeAddress')"
        />
      </div>

      <p class="gray-text">Загрузите копию паспорта <br />2-3 страницы и страница с регистрацией</p>

      <v-file-input
        small-chips
        label="Загрузите фото паспорта"
        prepend-icon="mdi-camera"
        accept="image/png, image/jpeg, image/jpg"
        multiple
        @change="updatePassportFiles"
        @click:clear="clearFiles('passport')"
        :rules="[rules.requirePassportFiles]"
      />
      <div v-if="passportFiles.length">
        <div class="fileName" :key="`${index}-${name}`" v-for="({ name }, index) in passportFiles">{{ name }}</div>
      </div>

      <p class="gray-text">Загрузите фотографии ИНН (2-4 фото)</p>
      <v-file-input
        small-chips
        label="Загрузите фото ИНН"
        prepend-icon="mdi-camera"
        accept="image/png, image/jpeg, image/jpg"
        multiple
        @change="updateInnFiles"
        @click:clear="clearFiles('inn')"
        :rules="[rules.requireInnFiles]"
      />

      <div v-if="innFiles.length">
        <div class="fileName" :key="`${index} ${name}`" v-for="({ name }, index) in innFiles">{{ name }}</div>
      </div>

      <p class="gray-text">Загрузите фотграфии СНИЛС(2-4 фото)</p>
      <v-file-input
        small-chips
        label="Загрузите фото СНИЛС"
        prepend-icon="mdi-camera"
        accept="image/png, image/jpeg, image/jpg"
        multiple
        @change="updateSnilsFiles"
        @click:clear="clearFiles('snils')"
        :rules="[rules.requireSnilsFiles]"
      />
      <div v-if="snilsFiles.length">
        <div class="fileName" :key="`${index} ${name}`" v-for="({ name }, index) in snilsFiles">{{ name }}</div>
      </div>

      <div class="checkbox-wrapper">
        <div class="politic-checkbox">
          <v-checkbox v-model="politicCheckbox" :rules="[rules.requirePolitic]" />

          <p class="politic">
            Я принимаю условия
            <a :href="promoCDN + `/pdf/agreement.pdf`" target="_blank">пользовательского соглашения</a>

            и соглашаюсь с
            <a :href="promoCDN + `/pdf/policy.pdf`" target="_blank">политикой обработки персональных данных</a>
          </p>
        </div>

        <div class="confirm-checkbox">
          <v-checkbox v-model="correctUserDataCheckBox" :rules="[rules.requireCorrectUserData]" />
          <p class="confirm">Я подтверждаю достоверность предоставленных мною данных</p>
        </div>
      </div>

      <v-btn block depressed color="primary" class="send-btn" type="submit" :disabled="!isFormValid" :loading="isLoading" @click="sendForm">
        <div class="btn-content-container">Отправить</div>
      </v-btn>
    </v-form>
    <v-snackbar v-model="snackbar.show" :timeout="snackbar.timeout" :color="snackbar.color" top center>
      {{ snackbar.message }}
    </v-snackbar>
  </div>
</template>

<script>
import axios from "axios";
import { mapActions } from "vuex";

export default {
  props: {
    rafflesId: { type: String, required: true },
    prizeName: { type: String, required: true },
  },
  data() {
    return {
      promoCDN: process.env.VUE_APP_PROMO_CDN,
      email: "",
      fio: "",
      birthDate: "",
      phone: "",
      inn: "",
      snils: "",
      bankAccountDetails: "",
      passportSerialNumber: "",
      passportWhenIssued: "",
      passportIssuedBy: "",
      passportRegistrationAddress: "",
      destinationPrizeAddress: "",
      files: [],
      politicCheckbox: false,
      correctUserDataCheckBox: false,
      isLoading: false,
      userPrize: "",
      passportFiles: [],
      innFiles: [],
      snilsFiles: [],

      snackbar: {
        show: false,
        message: "",
        timeout: 5000,
        color: "error",
      },

      rules: {
        requiredEmail: this.emailRules,
        requiredFio: this.fioRules,
        requiredBirthDate: this.birthDateRules,
        requiredPhone: this.phoneRules,
        requiredInn: this.innRules,
        requiredSnils: this.snilsRules,
        requiredBankAccountDetails: this.bankAccountDetailsRules,
        requiredDestinationPrizeAddress: this.destinationPrizeAddressRules,
        requirePolitic: this.politicRules,
        requireCorrectUserData: this.userDataRules,
        requireFile: this.fileRules,
        requirePassportSerialNumber: this.passportSerialNumberRules,
        requirePassportWhenIssued: this.passportWhenIssuedRules,
        requirePassportIssueBy: this.passportIssuedByRules,
        requirePassportRegistrationAddress: this.passportRegistrationAddressRules,
        requirePassportFiles: this.requirePassportFiles,
        requireInnFiles: this.requireInnFiles,
        requireSnilsFiles: this.requireSnilsFiles,
        requireIssuedByRules: this.requireIssuedByRules,
      },
    };
  },
  watch: {
    prizeName(newVal) {
      this.userPrize = newVal;
    },
  },
  methods: {
    ...mapActions({
      getCurrentUserIdFromToken: "getCurrentUserIdFromToken",
      getUserData: "getUserData",
    }),
    validateField(fieldName) {
      switch (fieldName) {
        case "email":
          this.rules.requiredEmail();
          break;
        case "fio":
          this.rules.requiredFio();
          break;
        case "birthDate":
          this.rules.requiredBirthDate();
          break;
        case "phone":
          this.rules.requiredPhone();
          break;
        case "inn":
          this.rules.requiredInn();
          break;
        case "snils":
          this.rules.requiredSnils();
          break;
        case "passportSerialNumber":
          this.rules.passportSerialNumberRules();
          break;
        case "passportWhenIssued":
          this.rules.passportWhenIssuedRules();
          break;
        case "passportIssuedBy":
          this.rules.requireIssuedByRules();
          break;
        case "passportRegistrationAddress":
          this.rules.passportRegistrationAddressRules();
          break;
        case "bankAccountDetails":
          if (this.userPrize === "rub150k") {
            this.rules.requiredBankAccountDetails();
          }
          break;
        default:
          break;
      }
    },
    emailRules() {
      const pattern =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

      if (!this.email) return "Укажите ваш Email";
      if (!pattern.test(this.email)) return "Неверный формат почты";

      return true;
    },
    fioRules() {
      const trimmedFio = this.fio.replace(/\s+/g, " ").trim();
      if (!trimmedFio) return "Укажите ваше ФИО";

      const words = trimmedFio.split(" ");

      if (words.length < 2 || words.length > 4) {
        return "ФИО должно содержать:Имя,Фамилию,Отчество(при наличии)";
      }

      for (const word of words) {
        if (!/^[А-Яа-яЁё]+(-[А-Яа-яЁё]+)?$/.test(word)) {
          return "Некорректный формат ФИО";
        }
      }

      return true;
    },
    birthDateRules() {
      const pattern = /^\d{2}\.\d{2}\.\d{4}$/gm;
      if (!this.birthDate) return "Укажите дату рождения";
      if (!pattern.test(this.birthDate)) return "Проверьте формат даты: ДД.ММ.ГГГГ";

      const [day, month, year] = this.birthDate.split(".").map(Number);
      const date = new Date(year, month - 1, day);
      if (date.getFullYear() !== year || date.getMonth() + 1 !== month || date.getDate() !== day) {
        return "Укажите корректную дату";
      }

      if (date > new Date()) {
        return "Дата рождения не может быть в будущем";
      }

      if (year < 1930) {
        return "Укажите реальную дату рождения";
      }

      return true;
    },
    phoneRules() {
      const pattern = /^\+\d \(\d{3,3}\) \d{3,3}-\d{2,2}-\d{2,2}$/gm;

      if (!this.phone) return "Укажите ваш телефон";
      if (!pattern.test(this.phone)) return "Укажите действительный номер телефона";

      return true;
    },
    innRules() {
      if (!this.inn) return "Укажите ваш ИНН";
      if (this.inn.length !== 12) return "Укажите действительный номер ИНН";

      return true;
    },
    snilsRules() {
      if (!this.snils) return "Укажите ваш СНИЛС";
      if (this.snils.length !== 11) return "Укажите действительный номер СНИЛС";

      return true;
    },
    bankAccountDetailsRules() {
      if (!this.bankAccountDetails) return "Укажите реквизиты банковского счета";
      return true;
    },
    destinationPrizeAddressRules() {
      if (!this.destinationPrizeAddress) return "Введите адрес доставки";

      return true;
    },
    politicRules() {
      if (!this.politicCheckbox) return false;
      return true;
    },
    userDataRules() {
      if (!this.correctUserDataCheckBox) return false;
      return true;
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
    requireIssuedByRules() {
      if (!this.passportIssuedBy) return "Введите кем выдан паспорт";

      const hasLetters = /[а-яА-Яa-zA-Z]/.test(this.passportIssuedBy);
      if (!hasLetters) return "Название организации должно содержать буквы";

      return true;
    },
    passportWhenIssuedRules() {
      const pattern = /^\d{2}\.\d{2}\.\d{4}$/gm;

      if (!this.passportWhenIssued) return "Укажите дату выдачи паспорта";
      if (!pattern.test(this.passportWhenIssued)) return "Проверьте вводимые данные";

      const [day, month, year] = this.passportWhenIssued.split(".").map(Number);
      const date = new Date(year, month - 1, day);
      if (date.getFullYear() !== year || date.getMonth() + 1 !== month || date.getDate() !== day) {
        return "Укажите корректную дату выдачи";
      }

      if (date > new Date()) {
        return "Дата выдачи не может быть в будущем";
      }

      return true;
    },
    requirePassportFiles() {
      if (!this.passportFiles || this.passportFiles.length < 2 || this.passportFiles.length > 4) {
        return "Загрузите от 2 до 4 файлов паспорта";
      }
      return true;
    },
    requireInnFiles() {
      if (!this.innFiles || this.innFiles.length < 2 || this.innFiles.length > 4) {
        return "Загрузите от 2 до 4 файлов ИНН";
      }
      return true;
    },
    requireSnilsFiles() {
      if (!this.snilsFiles || this.snilsFiles.length < 2 || this.snilsFiles.length > 4) {
        return "Загрузите от 2 до 4 файлов СНИЛС";
      }
      return true;
    },
    passportSerialNumberRules() {
      const pattern = /^\d{4} \d{6}$/gm;

      if (!this.passportSerialNumber) return "Введите серию и номер паспорта";
      if (!pattern.test(this.passportSerialNumber)) return "Укажите действительные номер и серию";

      return true;
    },
    issuedByRules() {
      if (!this.issuedBy) return "Введите кем и когда выдан";

      return true;
    },
    passportRegistrationAddressRules() {
      if (!this.passportRegistrationAddress) return "Введите адрес регистрации";

      return true;
    },
    updatePassportFiles(newFiles) {
      if (!newFiles) return;
      const newFileArray = Array.from(newFiles);
      this.passportFiles = [
        ...this.passportFiles,
        ...newFileArray.filter((newFile) => !this.passportFiles.some((existingFile) => existingFile.name === newFile.name)),
      ];
    },
    updateInnFiles(newFiles) {
      if (!newFiles) return;

      const newFileArray = Array.from(newFiles);

      this.innFiles = [
        ...this.innFiles,
        ...newFileArray.filter((newFile) => !this.innFiles.some((existingFile) => existingFile.name === newFile.name)),
      ];
    },
    updateSnilsFiles(newFiles) {
      if (!newFiles) return;
      const newFileArray = Array.from(newFiles);
      this.snilsFiles = [
        ...this.snilsFiles,
        ...newFileArray.filter((newFile) => !this.snilsFiles.some((existingFile) => existingFile.name === newFile.name)),
      ];
    },
    clearFiles(type) {
      if (type === "passport") this.passportFiles = [];
      if (type === "inn") this.innFiles = [];
      if (type === "snils") this.snilsFiles = [];
    },

    async sendForm() {
      try {
        const formData = new FormData();

        const isValid = await this.$refs.form.validate();
        if (!isValid) return;

        formData.append("accountId", this.$store.state.userIdFromToken);
        formData.append("rafflesId", this.rafflesId);
        formData.append("email", this.email);
        formData.append("fio", this.fio);
        formData.append("phone", this.phone);
        formData.append("birthDate", this.birthDate);
        formData.append("inn", Number(this.inn));
        formData.append("snils", this.snils);
        formData.append("passportSerialNumber", this.passportSerialNumber);
        formData.append("passportWhenIssued", this.passportWhenIssued);
        formData.append("passportIssuedBy", this.passportIssuedBy);
        formData.append("passportRegistrationAddress", this.passportRegistrationAddress);
        formData.append("destinationPrizeAddress", this.destinationPrizeAddress);
        if (this.userPrize === "rub150k") {
          formData.append("bankAccountDetails", this.bankAccountDetails || null);
        } else {
          formData.append("bankAccountDetails", null);
        }

        this.passportFiles.forEach((file) => {
          formData.append(`passportFile`, file);
        });
        this.innFiles.forEach((file) => {
          formData.append(`innFile`, file);
        });
        this.snilsFiles.forEach((file) => {
          formData.append(`snilsFile`, file);
        });

        this.isLoading = true;

        await axios.post(`${process.env.VUE_APP_MYHOST}/save-winner-data`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });

        this.$router.push({ name: "thankYou" }).catch(() => {});
      } catch (error) {
        let errorMessage = "Произошла ошибка";
        if (error.response) {
          if (error.response.data && error.response.data.message) {
            errorMessage = error.response.data.message;
          }
        }
        this.showError(errorMessage);
      } finally {
        this.isLoading = false;
      }
    },

    changeUserInfo() {
      this.email = this.$store.state.email.trim();
      this.fio = this.$store.state.fio.trim();
      this.phone = this.$store.state.phone.trim();
    },

    showError(message) {
      this.snackbar = {
        show: true,
        message: message,
        timeout: 5000,
        color: "error",
      };
    },
  },
  async mounted() {
    await this.getUserData();

    this.getCurrentUserIdFromToken();
    this.changeUserInfo();
  },
  computed: {
    isFormValid() {
      return (
        this.emailRules() === true &&
        this.fioRules() === true &&
        this.birthDateRules() === true &&
        this.phoneRules() === true &&
        this.innRules() === true &&
        this.snilsRules() === true &&
        (this.userPrize !== "rub150k" || this.bankAccountDetailsRules() === true) &&
        this.destinationPrizeAddressRules() === true &&
        this.passportSerialNumberRules() === true &&
        this.passportWhenIssuedRules() === true &&
        this.requireIssuedByRules() === true &&
        this.passportRegistrationAddressRules() === true &&
        this.requirePassportFiles() === true &&
        this.requireInnFiles() === true &&
        this.requireSnilsFiles() === true &&
        this.politicCheckbox &&
        this.correctUserDataCheckBox
      );
    },
  },
};
</script>

<style scoped>
.v-form {
  gap: 0;
}

.text {
  margin-bottom: 45px !important;
  max-width: 410px;
  align-self: center;
}

.politic-checkbox,
.confirm-checkbox {
  display: flex;
  align-items: center;
  gap: 14px;
}

.politic,
.confirm,
.fileName {
  text-align: left;
  font-size: 14px;
  color: #868686;
}

.inputs {
  display: flex;
  flex-direction: column;
  gap: 14px;
}
::v-deep .v-file-input .v-input__slot {
  background-color: transparent !important;
}
@media screen and (max-width: 4000px) and (min-width: 769px) {
  .wrapper-profile {
    max-width: 730px;
    width: 100%;
  }

  .v-form {
    border-radius: 10px;
    padding: 60px;
    gap: 0;
  }

  .v-form h2 {
    font: 700 40px "PT Sans";
  }

  .v-form .description {
    font-size: 18px;
  }

  .v-form .gray-text {
    font-size: 14px;
    color: #868686;
    margin-bottom: 5px !important;
  }

  .checkbox-wrapper {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .politic-checkbox,
  .confirm-checkbox {
    display: flex;
    gap: 14px;
  }

  .checkBox {
    height: 25px !important;
  }

  .politic,
  .confirm {
    text-align: left;
    font-size: 14px;
    color: #868686;
  }

  .politic a {
    color: #868686;
  }
}
</style>
